/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2023 NevWare21 Solutions LLC
 * Licensed under the MIT license.
 */
export var STR_PROMISE = "Promise";
export var DONE = "done";
export var VALUE = "value";
export var ITERATOR = "iterator";
export var RETURN = "return";
export var REJECTED = "rejected";
//# sourceMappingURL=constants.js.map